import { render, staticRenderFns } from "./promo-resource-tab-form-wrapper.vue?vue&type=template&id=098219e5"
import script from "./promo-resource-tab-form-wrapper.vue?vue&type=script&lang=js"
export * from "./promo-resource-tab-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports